import {
	SUCCESS_TOKEN_CM_DRCONSULTA,
	ERROR_TOKEN_CM_DRCONSULTA,
	SET_PAYMENT_METHOD
} from '../../actionType';
import cmdrconsulta from '../api/cmDrConsulta';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export const successGetTokenCmDrconsulta = payload => ({
	type: SUCCESS_TOKEN_CM_DRCONSULTA,
	payload
});
export const errorGetTokenCmDrConsulta = payload => ({
	type: ERROR_TOKEN_CM_DRCONSULTA,
	payload
});

export const setPaymentMethod = (method) => ({
  type: SET_PAYMENT_METHOD,
  payload: method,
});

export const verifyTokenCmDrConsulta = (
	signaturePLan,
	token
) => async dispatch => {
	const response = signaturePLan[0];

	if (response) {
		dispatch(successGetTokenCmDrconsulta(response));
	} else {
		const hasError = true;
		dispatch(errorGetTokenCmDrConsulta({ hasError }));
	}

	//------ metodo utilizado para verificação com token ----
	// try {
	// 	const responseToken = await cmdrconsulta.sendingToken(token);
	// 	let hasError = '';
	// 	if (responseToken === undefined) {
	// 		hasError = true;
	// 	} else if (responseToken.status === 200 && responseToken.data) {
	// 		dispatch(successGetTokenCmDrconsulta(response));
	// 		hasError = false;
	// 	} else {
	// 		hasError = 'true1';
	// 	}
	// 	return hasError;
	// } catch (err) {}
};

const mapStateToProps = actionObject => {
	return actionObject;
};
const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			verifyTokenCmDrConsulta
		},
		dispatch
	);

connect(mapStateToProps, mapDispatchToProps);
